import { ValidationTypeEnum } from '../../shared/model/enumerations/validation-type.enum';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class InputValidationService {
  constructor() {}

  isValidated(val: any, validationType: ValidationTypeEnum): boolean {
    let isVal = false;
    switch (validationType) {
      case ValidationTypeEnum.email: {
        const regexp = new RegExp(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
        isVal = !regexp.test(val);
        break;
      }

      case ValidationTypeEnum.numbers: {
        const regexp = RegExp('^[0-9]$');
        isVal = !regexp.test(val);
        break;
      }

      case ValidationTypeEnum.empty: {
        isVal = val == null || val === '' || val.$ngOptionValue === null;
        break;
      }

      case ValidationTypeEnum.required: {
        isVal = val == null || val === '' || val.$ngOptionValue === null;
        break;
      }

      case ValidationTypeEnum.nationalID: {
        // validate NationalID trough API...
        isVal = true;
        break;
      }

      case ValidationTypeEnum.insuranceLevel: {
        isVal = val == null || val === '' || val.$ngOptionValue === null || val === 1;
        break;
      }

      case ValidationTypeEnum.default: {
        if (!val) {
          isVal = true;
        }
        break;
      }
    }
    return isVal;
  }
}
